// Usage: import { Token } from 'lib/token';
//        const token = new Token();
//        token.getToken('token');
// Description: Token class for local storage
class Token {
  public getToken(key: string) {
    return localStorage.getItem(key);
  }

  public setToken(key: string, token: string) {
    localStorage.setItem(key, token);
  }

  public removeToken(key: string) {
    localStorage.removeItem(key);
  }
}


export default new Token();
